import { MtAccountPermissions } from "server/models"
import {
    GET,
    POST,
    AccountPermissions,
    ProjectPermissions,
    AccountPermissionsSectioned,
    ProjectPermissionsSectioned,

    createAccountPermissions,
    createProjectPermissions,
    copyAccountPermission,
    copyProjectPermission,
} from "client/store/utils"
import { LangType } from "client/store"


export const LoadAccountPermissions = (accountId: number, lang?: LangType) => (
    GET(`/mtAccountPermissions/accountId/${accountId}`)
    .then((permissions: { [key: number]: MtAccountPermissions }) => {
        const adminAccount = permissions[1] && permissions[1].permissions
            ? JSON.parse(permissions[1].permissions)
            : {}
        const adminProject = permissions[1] && permissions[1].projectPermissions
            ? JSON.parse(permissions[1].projectPermissions)
            : {}

        const account = permissions[accountId] && permissions[accountId].permissions
            ? JSON.parse(permissions[accountId].permissions)
            : {}
        const project = permissions[accountId] && permissions[accountId].projectPermissions
            ? JSON.parse(permissions[accountId].projectPermissions)
            : {}


        const initAccountPermissions = createAccountPermissions(lang || null)
        const accountPermissions = initAccountPermissions.permissions
        const accountPermissionsSectioned = initAccountPermissions.permissionsSectioned

        Object.keys(accountPermissionsSectioned).forEach((section) => {
            Object.keys(accountPermissionsSectioned[section]).forEach((permissionId: string) => {
                let resPermission = accountPermissions[permissionId]
                // copy users for "Help" permission
                resPermission = copyAccountPermission(resPermission, adminAccount[permissionId], true, true)
                resPermission = copyAccountPermission(resPermission, account[permissionId], true, false)

                accountPermissions[permissionId] = copyAccountPermission(accountPermissions[permissionId], resPermission, true, true)
                accountPermissionsSectioned[section][permissionId] = copyAccountPermission(
                    accountPermissionsSectioned[section][permissionId],
                    resPermission,
                    true,
                    true,
                )
            })
        })


        const initProjectPermissions = createProjectPermissions(lang || null)
        const projectPermissions = initProjectPermissions.permissions
        const projectPermissionsSectioned = initProjectPermissions.permissionsSectioned

        Object.keys(projectPermissionsSectioned).forEach((section) => {
            Object.keys(projectPermissionsSectioned[section]).forEach((permissionId) => {
                let resPermission = projectPermissions[permissionId]
                resPermission = copyProjectPermission(resPermission, adminProject[permissionId], false, true)
                resPermission = copyProjectPermission(resPermission, project[permissionId], true, true)

                projectPermissions[permissionId] = copyProjectPermission(projectPermissions[permissionId], resPermission, true, true)
                projectPermissionsSectioned[section][permissionId] = copyProjectPermission(
                    projectPermissionsSectioned[section][permissionId],
                    resPermission,
                    true,
                    true,
                )
            })
        })

        return {
            accountPermissions,
            accountPermissionsSectioned,
            projectPermissions,
            projectPermissionsSectioned,
        }
    })
)

export const SaveAccountPermissions = (
    accountId: number,
    accountPermissionsSectioned: AccountPermissionsSectioned,
    projectPermissionsSetcioned: ProjectPermissionsSectioned,
) => {
    const accountPermissions: AccountPermissions = {}
    const projectPermissions: ProjectPermissions = {}

    Object.keys(accountPermissionsSectioned).forEach((section) => {
        Object.keys(accountPermissionsSectioned[section]).forEach((permissionId) => {
            accountPermissions[permissionId] = accountPermissionsSectioned[section][permissionId]
        })
    })

    Object.keys(projectPermissionsSetcioned).forEach((section) => {
        Object.keys(projectPermissionsSetcioned[section]).forEach((permissionId) => {
            projectPermissions[permissionId] = projectPermissionsSetcioned[section][permissionId]
        })
    })

    const data: MtAccountPermissions = {
        accountId,
        permissions: JSON.stringify(accountPermissions),
        projectPermissions: JSON.stringify(projectPermissions),
    }

    return POST(
        "/mtAccountPermissions/save",
        JSON.stringify(data),
    )
}
